module.exports = __webpack_public_path__ + "media/app/images/sponsorship_cta@2x-281d6408a5dfe141d6bf13e9f0ebaaf8.png";